<div *ngIf="panel" [id]="panelId" class="panel-wrapper">
  <mat-expansion-panel (opened)="handleOpened()" (closed)="handleClosed()" hideToggle="true"
                       [expanded]="panelOpenState"
                       id="{{panel.title | stripSpecialChars}}-category"
                       class="main-panel mt-3 overflow-visible">
    <mat-expansion-panel-header tabindex="-1" [style.background-color]="color" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="main-header taxanomy-header p-0">
      <mat-panel-title class="align-items-center">
        <img class="taxanomy-img" [src]="image" alt="" loading="lazy">
        <h3>{{panel.title}}</h3>
        <div class="arrows" tabindex="0" role="button" [attr.aria-expanded]="panelOpenState" [attr.aria-label]="(panelOpenState ? 'Collapse' : 'Expand') + ' ' + panel.title">
          <img class="taxanomy-arrow-up" *ngIf="panelOpenState"
               src="../../../../../assets/action-plan-icons/Arrow@2x.png" alt="" loading="lazy">
          <img class="taxanomy-arrow-down" *ngIf="!panelOpenState"
               src="../../../../../assets/action-plan-icons/ArrowDown@2x.png" alt="" loading="lazy">
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <kla-action-taxonomy-goal *ngFor="let subPanel of panel.list"
                              [columnNames]="columnNames"
                              [columnsActive]="columnsActive"
                              [categories]="categories"
                              [config]="subPanel"
                              [color]="color"
                              [collapseChildren]="collapseChildren">

    </kla-action-taxonomy-goal>
  </mat-expansion-panel>
</div>
